import React from 'react'
import { BsTwitter, BsInstagram, BsLinkedin } from "react-icons/bs";
import { AiFillGithub } from 'react-icons/ai';
import { SiLeetcode } from 'react-icons/si';
// import { FaFacebookF } from "react-icons/fa";

const SocialMedia = () => {
    return (
        <div className='app__social'>
            <div>
                <a href='https://github.com/amansaurabh/' target='_blank'>
                    <AiFillGithub />
                </a>
            </div>
            <div>
                <a href="https://www.linkedin.com/in/amansaurabh" target='_blank'>
                    <BsLinkedin />
                </a>
            </div>
            <div>
                <a href="https://leetcode.com/amanSaurabh/" target='_blank'>
                    <SiLeetcode />
                </a>
            </div>
        </div>
    )
}

export default SocialMedia
